import * as React from 'react';
const GridRootPropsContext = /*#__PURE__*/React.createContext(undefined);

if (process.env.NODE_ENV !== 'production') {
  GridRootPropsContext.displayName = 'GridRootPropsContext';
}

export { GridRootPropsContext };